import axios from "api/axios"
import {
  APIResponse,
  Config,
  ConfigWithURLParams,
  NoContentType,
} from "api/types"
import { formatErrorResponse, formatSuccessResponse } from "api/utils"

import { Document, DocumentTag } from "./types"
import { urls } from "./urls"

export default {
  /** Optional filters: tags (any of, repeated param) and search (name, case-insensitive) */
  list: async ({
    tags = [],
    search = "",
  }: { tags?: string[]; search?: string } = {}): Promise<
    APIResponse<Document[]>
  > => {
    try {
      const trimmed = search.trim()
      const res = await axios.get(urls.documents.list(), {
        params: {
          ...(tags.length > 0 && { tags }),
          // The shared paramsSerializer doesn't encode values
          ...(trimmed && { search: encodeURIComponent(trimmed) }),
        },
      })
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  tags: async (): Promise<APIResponse<DocumentTag[]>> => {
    try {
      const res = await axios.get(urls.documents.tags())
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  /** `data` is FormData: file, tags (repeated), optional name */
  create: async ({ data }: Config): Promise<APIResponse<Document>> => {
    try {
      const res = await axios.post(urls.documents.list(), data)
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  /** `data` is FormData with only the changed fields */
  update: async ({
    urlParams,
    data,
  }: ConfigWithURLParams<"documentId">): Promise<APIResponse<Document>> => {
    try {
      const res = await axios.patch(
        urls.documents.detail(urlParams.documentId),
        data
      )
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  remove: async ({
    urlParams,
  }: ConfigWithURLParams<"documentId">): Promise<
    APIResponse<NoContentType>
  > => {
    try {
      const res = await axios.delete(
        urls.documents.detail(urlParams.documentId)
      )
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
}
